import React, { useState } from "react";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Table,
} from "antd";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { bankDepositsTableData, glAccounts, payers } from "../../../../data/accounting";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import { FaDollarSign } from "react-icons/fa";

import "./BankDeposits.css";
import TreeMultiSelect from "../../../../components/common/TreeSelect";
import { useNavigate } from "react-router-dom";

const ReceivableBankDepositRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Tenant Receipt", "1", "", "", "/accounting/receivables_payments/reciepts/tenant_receipts/new"),
    RightBarMethod("Homeowner Receipt", "2", "", "", "/accounting/receivables_payments/reciepts//HomeownerReceipt"),
    RightBarMethod("Other Receipt", "3", "", "", "/accounting/receivables_payments/reciepts/otherReceipt"),
    RightBarMethod("Application Fee", "5", "", "", "/accounting/receivables_payments/reciepts/newapplicationfee"),
    RightBarMethod("Tenant Charge", "6", "", "", "/accounting/receivables_payments/invoices/tenantcharge"),
    RightBarMethod("Homeowner Charge", "7", "", "", "/accounting/receivables_payments/invoices/homeownercharge"),
    RightBarMethod("Tenant Credit", "10", "", "", "/accounting/receivables_payments/invoices/newtenantcredit"),
    RightBarMethod("Homeowner Credit", "11", "", "", "/accounting/receivables_payments/invoices/newhomeownercredit"),
    RightBarMethod("Apply Credits", "12", "", "", "/accounting/receivables_payments/reciepts/applycredits"),
    RightBarMethod("Common Charge", "13", "", "", "/accounting/receivables_payments/invoices/NewCommonCharge"),
    RightBarMethod("Charge Late Fees", "14", "", "", "/accounting/receivables_payments/chargelatefees"),
    RightBarMethod("New Bank Deposit", "15", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),

  ]),
];

function Bank_Deposits() {
  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Deposite Date",
      width: "fit-content",
      dataIndex: "depositDate",
      key: "depositDate",
      sorter: (a, b) => a.depositDate.length - b.depositDate.length,
      sortOrder:
        sortedInfo.columnKey === "depositDate" ? sortedInfo.order : null,
    },
    {
      title: "Bank Account",
      dataIndex: "bankAccount",
      key: "bankAccount",
      sorter: (a, b) => a.bankAccount.length - b.bankAccount.length,
      sortOrder:
        sortedInfo.columnKey === "bankAccount" ? sortedInfo.order : null,
    },
    {
      title: "Deposit Number",
      dataIndex: "depositNumber",
      key: "depositNumber",
      sorter: (a, b) => a.depositNumber.length - b.depositNumber.length,
      sortOrder:
        sortedInfo.columnKey === "depositNumber" ? sortedInfo.order : null,
    },
    {
      title: "Property-Unit",
      dataIndex: "propertyUnit",
      key: "propertyUnit",
      sorter: (a, b) => a.propertyUnit.length - b.propertyUnit.length,
      sortOrder:
        sortedInfo.columnKey === "propertyUnit" ? sortedInfo.order : null,
    },
    {
      title: "Original Amount",
      dataIndex: "originalAmount",
      key: "originalAmount",
      sorter: (a, b) => a.originalAmount.length - b.originalAmount.length,
      sortOrder:
        sortedInfo.columnKey === "originalAmount" ? sortedInfo.order : null,
    },
    {
      title: "Updated Amount",
      dataIndex: "updatedAmount",
      key: "updatedAmount",
      sorter: (a, b) => a.updatedAmount.length - b.updatedAmount.length,
      sortOrder:
        sortedInfo.columnKey === "updatedAmount" ? sortedInfo.order : null,
    },
    {
      title: "Action",
      key: "action",
      render: () => <Button>Print</Button>,
    },
  ];
  return (
    <>
      <div className="bank-deposits">
        <PageHeading heading="Bank Deposits" />
        <Row>
          <Col span={24}>
            <FilterContainer
              heading={"Filter bank deposits with the options below."}
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Units">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by units"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Select
                        options={[
                          { value: "Show Active Properties" },
                          { value: "Show All Properties" },
                          { value: "Show Hidden Properties" },
                        ]}
                        defaultValue="Show Active Properties"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payers">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by Payers"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="GL Accounts">
                      <TreeMultiSelect
                        options={[]}
                        placeholder="Select GL Account"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Deposite #">
                      <Input placeholder="Search by deposite #" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Amount">
                      <InputNumber
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="From" required>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row>
          <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/receivables_payments/bank_deposits/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReceivableBankDepositRightBar} />
      </div>
    </>
  );
}

export default Bank_Deposits;
